export default __webpack_public_path__ + "static/media/pamm.d9bea6f9.png";